import { Container, Grid, Box, Typography, Button } from '@mui/material'
import { SigninImg, SigninLogo } from 'app/signin/styles'
import Carousel from 'components/carousel'
import useNavigation from 'hooks/useNavigation'
import { listImages } from 'utils/catalogs'

export default function PasswordChanged() {
  const { onNavigate } = useNavigation()
  const handleRedirect = () => {
    onNavigate('/login')
  }
  return (
    <Container>
      <Grid
        container
        paddingX={8}
        spacing={5}
        padding={0}
        justifyContent="center"
      >
        <Grid item md={5} paddingY={5}>
          <SigninLogo src="/images/logo.png" alt="logo" />
          <Box paddingTop={5} paddingRight={5}>
            <Typography variant="h1" paddingX="8px" paddingBottom={4}>
              Thank you!!
            </Typography>
            <Typography variant="body1" paddingX="8px" paddingBottom={4}>
              Your new password was successfully created, you can now start
              using BeeGopp.
            </Typography>
            <Button variant="contained" onClick={handleRedirect} fullWidth>
              Log In
            </Button>
          </Box>
        </Grid>
        <Grid
          item
          md={6}
          sx={{
            display: { xs: 'none', md: 'block' }
          }}
        >
          <Carousel loop autoPlay interval={5000}>
            {listImages.map(item => (
              <SigninImg key={item.id} src={item.img} alt="logo" />
            ))}
          </Carousel>
        </Grid>
      </Grid>
    </Container>
  )
}
